import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@material-ui/core";
import { updateHeight } from "../common";
import Contact from "./Contact";
import Subscribe from "./Subscribe";
import PoweredBy from "../powered-by";
import "./index.css";
import Promo from "./Promo";

const Form = () => {
  const { id } = useParams();
  const [model, setModel] = useState();

  useEffect(() => {
    if (!model) {
      window.parent.postMessage(
        { type: "form", key: "getData", value: { id: id } },
        "*"
      );

      window.addEventListener("message", (event) => {
        let data = event.data;
        if (data.type != "form") return;

        if (data.key == "setData") {
          setModel(data.value);
          updateHeight("form", { id });
        }
      });
    }
    //console.log("model", model);
  }, [model]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      {model && model.type == 1 && <Contact model={model} />}
      {model && model.type == 2 && <Subscribe model={model} />}
      {model && model.type == 3 && <Promo model={model} />}
      {model && (
        <PoweredBy
          widget={"form"}
          align={model.type == 3 ? "center" : "right"}
          color={model.type == 3 ? "#fff" : "#333"}
          dh={model.parent?.dh ?? ""}
        />
      )}
    </Box>
  );
};

export default Form;
